import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaCompass, FaHome, FaList, FaChartLine, FaUser, FaTimes } from 'react-icons/fa';

const QuickNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  
  // Pages where quick nav should be visible
  const showOnPages = ['/create-strategies', '/AboutStrategies', '/aboutStrategy', '/strategies-details'];
  const shouldShow = showOnPages.some(page => location.pathname.includes(page));
  
  useEffect(() => {
    // Close menu when clicking outside
    const handleClickOutside = (e) => {
      if (isOpen && !e.target.closest('.quick-nav')) {
        setIsOpen(false);
      }
    };
    
    if (isOpen) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [isOpen]);
  
  if (!shouldShow) {
    return null;
  }
  
  const quickLinks = [
    { path: '/dashboard', label: 'Dashboard', icon: <FaHome /> },
    { path: '/strategies', label: 'Strategies', icon: <FaList /> },
    { path: '/analytics', label: 'Analytics', icon: <FaChartLine /> },
    { path: '/profile', label: 'Profile', icon: <FaUser /> }
  ];
  
  return (
    <div className={`quick-nav ${isOpen ? 'open' : ''}`}>
      <button 
        className="quick-nav-toggle"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        aria-label="Quick Navigation"
        title="Quick Navigation"
      >
        {isOpen ? <FaTimes /> : <FaCompass />}
      </button>
      {isOpen && (
        <div className="quick-nav-menu">
          <div className="quick-nav-header">
            <h6>Quick Navigation</h6>
          </div>
          <div className="quick-nav-links">
            {quickLinks.map(link => {
              const isActive = location.pathname === link.path;
              return (
                <Link 
                  key={link.path} 
                  to={link.path}
                  className={`quick-nav-link ${isActive ? 'active' : ''}`}
                  onClick={() => setIsOpen(false)}
                >
                  <span className="quick-nav-icon">{link.icon}</span>
                  <span className="quick-nav-label">{link.label}</span>
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default QuickNav;
